import { supplierInternalGroups } from "./supplierAccess.mjs";

export default {
    title: 'Fornitori',
    icon: 'mdi-truck-fast',
    divider: true,
    groups: [...supplierInternalGroups, 'Fornitore'],
    submenu: [
        {title: 'Fornitori attivi', groups: supplierInternalGroups, route: {name: 'Fornitori'}},
        {title: 'Area fornitore', groups: ['Fornitore'], excludeGroups: supplierInternalGroups, route: {name: 'fornitore-magazzino', query: {view: 'summary'}}},
    ]
}
